import React, { useEffect, useState } from "react";
import { RegionsCardData } from "../../../api/controller/videoController/regions";

export default function AdminContactStaffDialogBox({ open, onClose, onSave, initial = null, isSaving = false }) {
	const [form, setForm] = useState({ name: "", email: "", role: "", title: "", bio: "", imageFile: null, regions: [] });
	const [regionsList, setRegionsList] = useState([]);

	useEffect(() => {
		let mounted = true;
		const loadRegions = async () => {
			try {
				const data = await RegionsCardData();
				if (mounted) setRegionsList(Array.isArray(data) ? data : []);
			} catch (err) {
				console.error('Failed to load regions for contact staff dialog', err);
			}
		};
		loadRegions();
		return () => { mounted = false; };
	}, []);

	useEffect(() => {
			if (initial) {
				setForm({
					name: initial.name || "",
					email: initial.email || "",
					role: initial.role || "",
					title: initial.title || "",
					bio: initial.bio || "",
					imageFile: null,
					regions: Array.isArray(initial.regions) ? initial.regions : (typeof initial.regions === 'string' && initial.regions ? initial.regions.split(',').map(s=>s.trim()).filter(Boolean) : []),
				});
			} else {
				setForm({ name: "", email: "", role: "", title: "", bio: "", imageFile: null, regions: [] });
			}
	}, [initial, open]);

	if (!open) return null;

	const handleChange = (e) => {
		const { name, value, files } = e.target;
		if (name === 'image') {
			setForm((f) => ({ ...f, imageFile: files && files[0] }));
			return;
		}
		setForm((f) => ({ ...f, [name]: value }));
	};

	const toggleRegion = (regionId) => {
		setForm((f) => {
			const next = f.regions.includes(regionId) ? f.regions.filter(r => r !== regionId) : [...f.regions, regionId];
			return { ...f, regions: next };
		});
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		if (isSaving) return;
		const fd = new FormData();
		fd.append('name', form.name || '');
			fd.append('email', form.email || '');
		fd.append('role', form.role || '');
		fd.append('title', form.title || '');
		fd.append('bio', form.bio || '');
		// regions: send as CSV for backward compatibility
		if (Array.isArray(form.regions) && form.regions.length > 0) fd.append('regions', form.regions.join(','));
		else fd.append('regions', '');
		if (form.imageFile) fd.append('image', form.imageFile);
		onSave(fd);
	};

	return (
		<div className="fixed inset-0 bg-black/40 flex items-start justify-center z-50 p-4 sm:items-center">
			<div className="relative bg-white rounded shadow-lg w-full max-w-xl p-6 max-h-[90vh] overflow-y-auto">
				<button
					type="button"
					onClick={onClose}
					className="absolute top-3 right-3 text-gray-500 hover:text-gray-800 text-3xl font-bold leading-none"
					aria-label="Close dialog"
				>
					&times;
				</button>
				<h2 className="text-xl font-semibold mb-4">{initial ? 'Edit Contact Staff' : 'Add Contact Staff'}</h2>
				<form onSubmit={handleSubmit} className="space-y-4">
					<div>
						<label className="block text-sm font-medium mb-1">Name</label>
						<input name="name" value={form.name} onChange={handleChange} className="w-full border rounded p-2" />
					</div>

                    <div>
						<label className="block text-sm font-medium mb-1">Email</label>
						<input name="email" value={form.email} onChange={handleChange} className="w-full border rounded p-2" />
					</div>

					<div className="grid grid-cols-2 gap-4">
						<div>
							<label className="block text-sm font-medium mb-1">Role</label>
							<input name="role" value={form.role} onChange={handleChange} className="w-full border rounded p-2" />
						</div>
						<div>
							<label className="block text-sm font-medium mb-1">Title</label>
							<input name="title" value={form.title} onChange={handleChange} className="w-full border rounded p-2" />
						</div>
					</div>

					<div>
						<label className="block text-sm font-medium mb-1">Bio</label>
						<textarea name="bio" value={form.bio} onChange={handleChange} className="w-full border rounded p-2" />
					</div>

					<div>
						<label className="block text-sm font-medium mb-1">Image (optional)</label>
						<input type="file" name="image" accept="image/*" onChange={handleChange} />
					</div>

					<div>
						<label className="block text-sm font-medium mb-2">Regions</label>
						<div className="grid grid-cols-2 gap-2 max-h-48 overflow-auto border border-gray-200 p-2 rounded">
							{regionsList.map((r) => (
								<label key={r._id || r.city} className="flex items-center gap-2">
									<input type="checkbox" checked={form.regions.includes(r._id)} onChange={() => toggleRegion(r._id)} />
									<span className="text-sm">{r.city}{r.state ? `, ${r.state}` : ''}</span>
								</label>
							))}
							{regionsList.length === 0 && <div className="text-sm text-gray-500">No regions available</div>}
						</div>
					</div>

					<div className="flex justify-end gap-3">
						<button type="button" onClick={onClose} className="px-4 py-2 border rounded" disabled={isSaving}>Cancel</button>
						<button type="submit" className={`px-4 py-2 rounded text-white ${isSaving ? "bg-blue-300 cursor-not-allowed" : "bg-blue-600 hover:bg-blue-700"}`} disabled={isSaving}>
							{isSaving ? 'Saving...' : 'Save'}
						</button>
					</div>
				</form>
			</div>
		</div>
	);
}

